<template>
    <div class="commentMain">
        <div style="display: flex; align-items: center;">
            <img
                class="userAvatar"
                :src="wxAvatar"
                v-if="wxAvatar"
            />
            <div v-else class="userAvatar" />
            <div class="userInfo">
                用户{{ evaluationUserPetName }}
            </div>
        </div>
        <div class="horizonGully" />
        <div style="display: flex;">
            <div style="flex-shrink: 0;">
                {{ evaluationOfGoodsTime }}
            </div>
            <div class="verticalGully" />
            <div style="flex-grow:1;overflow:auto;">
                规格{{ productName }}
            </div>
        </div>
        <div v-show="evaluationOfGoodsMsg && evaluationOfGoodsMsg.length" class="horizonGully" />
        <div>
            {{ evaluationOfGoodsMsg }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Comment',

    props: {
        wxAvatar: {
            type: String,
        },

        evaluationUserPetName: {
            type: String,
        },

        evaluationOfGoodsTime: {
            type: String,
        },

        evaluationOfGoodsMsg: {
            type: String,
        },

        productName: {
            type: String,
        },
    },
}
</script>

<style lang="scss" scoped>

.commentMain
{
    font-size: $fontSizeContent;
    line-height: 2em;
}

.userAvatar
{
    width: 3em;
    height: 3em;
    margin-right: $margin;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}

.userInfo
{
    flex-grow: 1;
    overflow: auto;
    white-space: nowrap;
}

</style>